export interface INavigationRoute3 {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute3[]
}

//门店管理员菜单
export default {
  root: {
    name: '/',
    displayName: 'Storemanager.home',
  },
  routes: [
    {
      name: 'home',
      displayName: 'menu.home',
      meta: {
        icon: 'material-icons-cloud_upload',
      },
    },
     {
      name: 'themeManagement',
      displayName: 'menu.themeManagement',
      meta: {
       icon: 'material-icons-event_note',
      },
      children: [
        {
          name: 'themeList',
          displayName: 'menu.themeList',
        },
        //  {
        //   name:'themeTemplateList',
        //   displayName: 'menu.themeTemplateList'
        // }
      ],
    },
     {
      name: 'templateManagement',
      displayName: 'menu.themeTemplateList',
      meta: {
        icon: 'material-icons-view_quilt',
      },
      children:[
        {
          name:'themeTemplateList',
          displayName: 'menu.themeTemplateList'
        },
        // {
        //   name: 'themeTagList',
        //   displayName: 'menu.themeTagList',
        // },
      ]
    },
    {
      name: 'assetManagement',
      displayName: 'menu.assetManagement',
      meta: {
        icon: 'material-icons-photo_library',
      },
      children: [
        {
          name: 'assetList',
          displayName: 'menu.assetList',
        },
      ],
    },
     {
      name: 'shopManagement',
      displayName: 'menu.shopManagement',
      meta: {
         icon: 'material-icons-store',
      },
      children: [
        {
          name: 'shopList',
          displayName: 'menu.shopList',
        },
        // {
        //   name: 'ShopAssociatedTerminals',
        //   displayName: 'menu.ShopAssociatedTerminals',
        // },
        // {
        //   name: 'ShopAssociatedAccount',
        //   displayName: 'menu.ShopAssociatedAccount',
        // },
      ],
    },
    // {
    //   name: 'accountManagement',
    //   displayName: 'menu.accountManagement',
    //   meta: {
    //     icon: 'group',
    //   },
    //   children: [
    //     {
    //       name: 'accountList',
    //       displayName: 'menu.accountList',
    //     },
    //     {
    //       name: 'menuList',
    //       displayName: 'menu.menuList',
    //     },
    //     {
    //       name: 'roleList',
    //       displayName: 'menu.roleList',
    //     },
    //   ],
    // },
    //终端管理
    {
      name: 'TerminalManagement',
      displayName: 'menu.TerminalManagement',
      meta: {
        icon: 'material-icons-terminal',
      },
      children: [
        {
          name: 'TerminalList',
          displayName: 'menu.TerminalList',
        },
        // {
        //   name: 'TerminalAssociatedTheme',
        //   displayName: 'menu.TerminalAssociatedTheme',
        // },
      ],
    },
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'material-icons-dashboard',
      },
    },
    {
      name: 'updateLog',
      displayName: 'menu.updateLog',
      meta: {
        icon: 'material-icons-history',
      },
    },
    // {
    //   name: 'assetManagement',
    //   displayName: 'menu.assetManagement',
    //   meta: {
    //     icon: 'login',
    //   },
    //   children: [
    //     {
    //       name: 'assetTagList',
    //       displayName: 'menu.assetTagList',
    //     },
    //     {
    //       name: 'assetList',
    //       displayName: 'menu.assetList',
    //     },
    //   ],
    // }
  ] as INavigationRoute3[],
}
